import createArrow from './helpers/createArrow';
import handleStickyHeader from './components/stickyNav';
import timeline from './components/timeline';
import { handleResourceTabs } from './components/resourceTabLogic';
import { setupFormHandler } from './helpers/directory';
import { populateDropdownsFromURL } from './helpers/populateDropdowns';
import initTabs from './components/tabs';

// use lodash! https://lodash.com/docs/4.17.15
const fndryThemeInitWrapper = () => {
	createArrow();
	handleStickyHeader();
	initTabs();
	handleResourceTabs();
	document.querySelectorAll( '.fndry-custom-timeline' ).forEach( timeline );
	setupFormHandler();
	populateDropdownsFromURL();
};

window.fndryThemeInitWrapper = fndryThemeInitWrapper;

// eslint-disable-next-line no-unused-expressions
document.body ? fndryThemeInitWrapper() : document.addEventListener( 'DOMContentLoaded', fndryThemeInitWrapper, false );
